import script from "./DigitizeAtSizeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitizeAtSizeDialog.vue?vue&type=script&setup=true&lang=js"

import "./DigitizeAtSizeDialog.vue?vue&type=style&index=0&id=77a4874d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a4874d"]])

export default __exports__